import { render, staticRenderFns } from "./MultiselectInputConfig.vue?vue&type=template&id=4c280a9a&"
import script from "./MultiselectInputConfig.vue?vue&type=script&lang=js&"
export * from "./MultiselectInputConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports